import request from '@/utils/request'

/**
 * 获取商品分类列表
 * @param {Object} params - 可选参数 { id, pid }
 * @returns {Promise}
 */
export function getCategoryList(params) {
    return request({
        url: '/shop/sort/api/list',
        method: 'get',
        params
    })
}
